import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col, Container } from "react-bootstrap";
import { ConvertStringToBoolean, ConvertBooleanToString } from "../../../Helpers/Formatters/ConvertBoolean";
import { CheckboxInput } from "../../../Helpers/Inputs";
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import BackNext from '../../Common/SubComponents/BackNext';
import { SvgIcon } from '@mui/material';
import { FLORIDA, NEW_YORK } from '../../../Helpers/Constants/States';
import Timer from '../icons/timer.svg?react'
import IneligibleForm from '../Helpers/Input/IneligibleForm';
import { setNestedValue } from '../Helpers/Constant';
import { string, object, array as yuparray } from 'yup';
import { customValidators } from '../../../Helpers/Validators/customValidators';

export default function FiveYearEligibility(props) {
    const state = props.basicInfo.state;
    const ineligibleDefault = [
        {
            type: '',
            name: [],
            numberOfChildren: '',
            nameofChildren: [],
        },
    ];
    const formMethods = useForm({
        resolver: yupResolver(FiveYearEligibility.ValidationSchema),
        mode: 'all',
        reValidateMode: 'all',
        defaultValues: props.formState
    });

    const { handleSubmit, trigger, register, setValue } = formMethods;
    useEffect(() => {
        props.onFieldChange("isVisible", true);
    }, [])
    const handleCheckBoxValue = (field, value) => {
        if (value) {
            const newForm = ineligibleDefault;
            newForm[0].type = field;
            props.onStepFieldChange(field, ConvertBooleanToString(value), 'ineligible', [...props.formState.ineligible, newForm[0]]);
            setValue('ineligible', [...props.formState.ineligible, newForm[0]]);
        } else {
            props.onStepFieldChange(
                field,
                value,
                'ineligible',
                props.formState.ineligible.filter((form, formIndex) => form.type !== field)
            );
            const selectedForm = props.formState.ineligible.filter((form, formIndex) => form.type === field);
            const newForms = props.formState.ineligible.filter((form, formIndex) => form.type !== field);
            let selectedFormIndex;
            if (props.formState.ineligible.length > 0) {
                selectedFormIndex = props.formState.ineligible.findIndex((form) => form.type === field);
            }
            if (selectedForm.length > 0 && selectedFormIndex >= 0) {
                register('ineligible');
                setValue('ineligible', newForms);
            }
        }
    };

    const getLabelForFiveYearEligibility = () => {
        if (state === NEW_YORK) {
            return "To the best of your knowledge and belief, within the last five years, has anyone to be covered been medically treated or diagnosed by a member of the medical profession as having any of the following?";
        } else if (state === FLORIDA) {
            return "Within the last five years, (two years for breast cancer), has anyone to be covered been medically treated or diagnosed by a licensed member of the medical profession as having any of the following?";
        } else {
            return "Within the last five years, has anyone to be covered been medically treated or diagnosed by a member of the medical profession as having any of the following?";
        }
    }

    const noneOfTheAboveDisabled = (
        props.formState.chronicObstructive === "true" ||
        props.formState.pulmonary === "true" ||
        props.formState.cysticFibrosis === "true" ||
        props.formState.cerebral === "true" ||
        props.formState.heartAttack === "true" ||
        props.formState.congenitalDefect === "true" ||
        props.formState.congestiveFailure === "true" ||
        props.formState.sickleCellAnemia === "true" ||
        props.formState.systemicLupus === "true" ||
        props.formState.multipleSclerosis === "true" ||
        props.formState.diabetesWithInsulin === "true" ||
        props.formState.diabetesAndTobacco === "true" ||
        props.formState.organTransplant === "true" ||
        props.formState.alcoholAbuse === "true" ||
        props.formState.tia === "true" ||
        props.formState.heartSurgery === "true" ||
        props.formState.cardiomyopathy === "true" ||
        props.formState.nonmelanoma === "true" ||
        props.formState.muscularDystrophy === "true" ||
        props.formState.psoriaticArthritis === "true" ||
        props.formState.liveDisease === "true" ||
        props.formState.diabetesWithComplication === "true" ||
        props.formState.kidneyDisease === "true"
    );
    useEffect(() => {
        if (noneOfTheAboveDisabled && props.formState.none === 'true') {
            props.onFieldChange('none', 'false');
        } else if (noneOfTheAboveDisabled && props.formState.none !== 'true') {
            trigger('none');
        }
        else if (!noneOfTheAboveDisabled && props.formState.none === 'false') {
            props.onFieldChange('none', 'true');
        }
    }, [noneOfTheAboveDisabled]);


    const getIneligibleComponent = (field, list) => {
        let item;
        list.map((ineligible, index) => {
            if (ineligible.type === field) {
                item = ineligible;
                item.index = index;
            }
        });
        const handleValueChangeloop = (field, type, value, longFieldName) => {
            setValue(longFieldName, value);
            props.onFieldChange(
                'ineligible',
                props.formState.ineligible.map((form, formIndex) => {
                    if (type === form.type) {
                        if (field === "name")
                            form[field] = value;
                        else
                            setNestedValue(form, field, value);
                        return form;
                    } else {
                        return form;
                    }
                })
            );
        };
        const handleChildrenNames = (field, type, value, longFieldName) => {
            const resetIneligible = props.formState.ineligible.map((form, formIndex) => {
                if (type === form.type) {
                    if (field === 'numberOfChildren') {
                        setNestedValue(form, field, value);
                        const previousChildLength = form.nameofChildren.length;
                        const totalChild = parseInt(value);
                        if (totalChild > previousChildLength) {
                            const addChildInput = totalChild - previousChildLength;
                            for (let i = 1; i <= addChildInput; i++) {
                                if (type === form.type) {
                                    form.nameofChildren.push({ name: '' });
                                }
                            }
                        } else {
                            const removeChildInput = previousChildLength - totalChild;
                            form.nameofChildren.splice(`-${removeChildInput}`);
                        }
                        return form;
                    }
                } else {
                    if (type === form.type) {
                        setNestedValue(form, field, value);
                        return form;
                    } else {
                        return form;
                    }
                }
            })
            props.onFieldChange('ineligible', resetIneligible);
            setValue('ineligible', resetIneligible);
        };
        if (item) {
            return (
                <div>
                    <IneligibleForm
                        formState={item}
                        onChange={(field, value, type, longFieldName) => {
                            handleValueChangeloop(field, type, value, longFieldName);
                        }}
                        ChildChange={(field, value, type, longFieldName) => {
                            handleChildrenNames(field, type, value, longFieldName);
                        }}
                        allProps={props}
                        trigger={trigger}
                        key={item.index}
                        index={item.index}
                        customOption={props.getListOfPlanIncludedPerson()}
                        noOfChilds={props.noOfChilds ? props.noOfChilds : ''}
                    />
                </div>
            );
        }
    };

    return (
        <Container fluid className='border-class fiveYearEligibility'>
            <FormProvider {...formMethods}>
                <Form className="formPage" onSubmit={handleSubmit(props.onNext)}>
                    <Row className="justify-content-center mt-4">
                        <Col lg={6}>
                            <div className="text-center mb-2 pt-4">  <SvgIcon component={Timer} className="small-icons" color="primary" fontSize="large" /></div>
                            <div className="text-center form-title pb-2">5 Year Medical History</div>
                        </Col>
                    </Row>
                    <Row className="formPage justify-content-center">
                        <Col lg={5}>
                            <h6 className='pb-1'>{getLabelForFiveYearEligibility()}</h6>
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="chronicObstructive"
                                    id="chronicObstructive"
                                    checked={ConvertStringToBoolean(props.formState.chronicObstructive)}
                                    onChange={e => handleCheckBoxValue('chronicObstructive', e.target.checked)}
                                    label="Chronic obstructive lung disease, including chronic obstructive pulmonary disease"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.chronicObstructive) && getIneligibleComponent('chronicObstructive', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="cerebral"
                                    id="cerebral"
                                    checked={ConvertStringToBoolean(props.formState.cerebral)}
                                    onChange={e => handleCheckBoxValue('cerebral', e.target.checked)}
                                    label="Cerebral vascular disease"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.cerebral) && getIneligibleComponent('cerebral', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="heartAttack"
                                    id="heartAttack"
                                    checked={ConvertStringToBoolean(props.formState.heartAttack)}
                                    onChange={e => handleCheckBoxValue('heartAttack', e.target.checked)}
                                    label="Heart attack"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.heartAttack) && getIneligibleComponent('heartAttack', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="congenitalDefect"
                                    id="congenitalDefect"
                                    checked={ConvertStringToBoolean(props.formState.congenitalDefect)}
                                    onChange={e => handleCheckBoxValue('congenitalDefect', e.target.checked)}
                                    label="Uncorrected congenital heart defect"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.congenitalDefect) && getIneligibleComponent('congenitalDefect', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="congestiveFailure"
                                    id="congestiveFailure"
                                    checked={ConvertStringToBoolean(props.formState.congestiveFailure)}
                                    onChange={e => handleCheckBoxValue('congestiveFailure', e.target.checked)}
                                    label="Congestive heart failure"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.congestiveFailure) && getIneligibleComponent('congestiveFailure', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="sickleCellAnemia"
                                    id="sickleCellAnemia"
                                    checked={ConvertStringToBoolean(props.formState.sickleCellAnemia)}
                                    onChange={e => handleCheckBoxValue('sickleCellAnemia', e.target.checked)}
                                    label="Sickle cell anemia"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.sickleCellAnemia) && getIneligibleComponent('sickleCellAnemia', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="systemicLupus"
                                    id="systemicLupus"
                                    checked={ConvertStringToBoolean(props.formState.systemicLupus)}
                                    onChange={e => handleCheckBoxValue('systemicLupus', e.target.checked)}
                                    label="Systemic lupus"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.systemicLupus) && getIneligibleComponent('systemicLupus', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="multipleSclerosis"
                                    id="multipleSclerosis"
                                    checked={ConvertStringToBoolean(props.formState.multipleSclerosis)}
                                    onChange={e => handleCheckBoxValue('multipleSclerosis', e.target.checked)}
                                    label="Multiple sclerosis"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.multipleSclerosis) && getIneligibleComponent('multipleSclerosis', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="diabetesWithInsulin"
                                    id="diabetesWithInsulin"
                                    checked={ConvertStringToBoolean(props.formState.diabetesWithInsulin)}
                                    onChange={e => handleCheckBoxValue('diabetesWithInsulin', e.target.checked)}
                                    label="Diabetes treated with insulin or other injectable medication"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.diabetesWithInsulin) && getIneligibleComponent('diabetesWithInsulin', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="diabetesAndTobacco"
                                    id="diabetesAndTobacco"
                                    checked={ConvertStringToBoolean(props.formState.diabetesAndTobacco)}
                                    onChange={e => handleCheckBoxValue('diabetesAndTobacco', e.target.checked)}
                                    label="Diabetes and used tobacco after the diagnosis"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.diabetesAndTobacco) && getIneligibleComponent('diabetesAndTobacco', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="organTransplant"
                                    id="organTransplant"
                                    checked={ConvertStringToBoolean(props.formState.organTransplant)}
                                    onChange={e => handleCheckBoxValue('organTransplant', e.target.checked)}
                                    label="Organ or bone marrow transplant"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.organTransplant) && getIneligibleComponent('organTransplant', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="alcoholAbuse"
                                    id="alcoholAbuse"
                                    checked={ConvertStringToBoolean(props.formState.alcoholAbuse)}
                                    onChange={e => handleCheckBoxValue('alcoholAbuse', e.target.checked)}
                                    label="Alcohol or drug abuse"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.alcoholAbuse) && getIneligibleComponent('alcoholAbuse', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="pulmonary"
                                    id="pulmonary"
                                    checked={ConvertStringToBoolean(props.formState.pulmonary)}
                                    onChange={e => handleCheckBoxValue('pulmonary', e.target.checked)}
                                    label="Pulmonary fibrosis"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.pulmonary) && getIneligibleComponent('pulmonary', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="cysticFibrosis"
                                    id="cysticFibrosis"
                                    checked={ConvertStringToBoolean(props.formState.cysticFibrosis)}
                                    onChange={e => handleCheckBoxValue('cysticFibrosis', e.target.checked)}
                                    label="Cystic fibrosis"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.cysticFibrosis) && getIneligibleComponent('cysticFibrosis', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="tia"
                                    id="tia"
                                    checked={ConvertStringToBoolean(props.formState.tia)}
                                    onChange={e => handleCheckBoxValue('tia', e.target.checked)}
                                    label="Stroke or transient ischemic attack (TIA)"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.tia) && getIneligibleComponent('tia', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="heartSurgery"
                                    id="heartSurgery"
                                    checked={ConvertStringToBoolean(props.formState.heartSurgery)}
                                    onChange={e => handleCheckBoxValue('heartSurgery', e.target.checked)}
                                    label="Heart bypass surgery, stent placement, or angioplasty"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.heartSurgery) && getIneligibleComponent('heartSurgery', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="cardiomyopathy"
                                    id="cardiomyopathy"
                                    checked={ConvertStringToBoolean(props.formState.cardiomyopathy)}
                                    onChange={e => handleCheckBoxValue('cardiomyopathy', e.target.checked)}
                                    label="Cardiomyopathy"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.cardiomyopathy) && getIneligibleComponent('cardiomyopathy', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="nonmelanoma"
                                    id="nonmelanoma"
                                    checked={ConvertStringToBoolean(props.formState.nonmelanoma)}
                                    onChange={e => handleCheckBoxValue('nonmelanoma', e.target.checked)}
                                    label="Cancer, other than nonmelanoma skin cancer"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.nonmelanoma) && getIneligibleComponent('nonmelanoma', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="muscularDystrophy"
                                    id="muscularDystrophy"
                                    checked={ConvertStringToBoolean(props.formState.muscularDystrophy)}
                                    onChange={e => handleCheckBoxValue('muscularDystrophy', e.target.checked)}
                                    label="Muscular dystrophy"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.muscularDystrophy) && getIneligibleComponent('muscularDystrophy', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="psoriaticArthritis"
                                    id="psoriaticArthritis"
                                    checked={ConvertStringToBoolean(props.formState.psoriaticArthritis)}
                                    onChange={e => handleCheckBoxValue('psoriaticArthritis', e.target.checked)}
                                    label="Psoriatic arthritis"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.psoriaticArthritis) && getIneligibleComponent('psoriaticArthritis', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="liveDisease"
                                    id="liveDisease"
                                    checked={ConvertStringToBoolean(props.formState.liveDisease)}
                                    onChange={e => handleCheckBoxValue('liveDisease', e.target.checked)}
                                    label="Liver disease or disorder"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.liveDisease) && getIneligibleComponent('liveDisease', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="diabetesWithComplication"
                                    id="diabetesWithComplication"
                                    checked={ConvertStringToBoolean(props.formState.diabetesWithComplication)}
                                    onChange={e => handleCheckBoxValue('diabetesWithComplication', e.target.checked)}
                                    label="Diabetes with complications, including but not limited to nephropathy, neuropathy, or retinopathy"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.diabetesWithComplication) && getIneligibleComponent('diabetesWithComplication', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="kidneyDisease"
                                    id="kidneyDisease"
                                    checked={ConvertStringToBoolean(props.formState.kidneyDisease)}
                                    onChange={e => handleCheckBoxValue('kidneyDisease', e.target.checked)}
                                    label="Kidney disease or disorder (except kidney stones)"
                                />
                            </div>
                            {ConvertStringToBoolean(props.formState.kidneyDisease) && getIneligibleComponent('kidneyDisease', props.formState.ineligible)}
                            <div className="checkboxes">
                                <CheckboxInput
                                    name="none"
                                    id="none"
                                    checked={noneOfTheAboveDisabled === true ? false : true}
                                    onChange={e => handleCheckBoxValue('none', e.target.checked)}
                                    label="None of the above"
                                    disabled={noneOfTheAboveDisabled}
                                />
                            </div>
                        </Col>
                    </Row>
                    <div className='backnext-wrapper'>
                        <BackNext onBack={props.onBack} isAflac={true} continueLabel={{ text: "Next" }} />
                    </div>
                </Form>
            </FormProvider>
        </Container >
    );
}

FiveYearEligibility.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
};
FiveYearEligibility.ValidationSchema = object().shape({
    ineligible: yuparray(
        object().shape({
            name: yuparray().of(string().required('Name is required.')).min(1, 'Name is required.'),
            numberOfChildren: string().when('name', {
                is: (name) => name && name.includes('Dependent Child'),
                then: (schema) => schema.required('This field is required.'),
                otherwise: (schema) => schema.notRequired(),
            }),
            nameofChildren: yuparray().when('name', {
                is: (name) => name && name.includes('Dependent Child'),
                then: (schema) => yuparray(
                    object().shape({
                        name: customValidators.string().isValidNameWithFiftyChar('Child Name is required.', true),
                    })
                ),
            }),
        })
    ),
});

FiveYearEligibility.DefaultFormState = (prefill = false) => {
    return {
        chronicObstructive: "false",
        pulmonary: "false",
        cysticFibrosis: "false",
        cerebral: "false",
        heartAttack: "false",
        congenitalDefect: "false",
        congestiveFailure: "false",
        sickleCellAnemia: "false",
        systemicLupus: "false",
        multipleSclerosis: "false",
        diabetesWithInsulin: "false",
        diabetesAndTobacco: "false",
        organTransplant: "false",
        alcoholAbuse: "false",
        tia: "false",
        heartSurgery: "false",
        cardiomyopathy: "false",
        nonmelanoma: "false",
        muscularDystrophy: "false",
        psoriaticArthritis: "false",
        liveDisease: "false",
        diabetesWithComplication: "false",
        kidneyDisease: "false",
        none: "true",
        ineligible: [],
        isVisible: false,
    };
};
